"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectStore = void 0;
const elf_1 = require("@ngneat/elf");
const elf_entities_1 = require("@ngneat/elf-entities");
const initState = () => ({
    campaigns: [],
    templates: {},
});
exports.projectStore = (0, elf_1.createStore)({ name: 'project' }, (0, elf_1.withProps)(initState()), (0, elf_entities_1.withEntities)());
//# sourceMappingURL=project.store.js.map